import {useDataGrid} from "../../../components/data-grid/DataGridContext";
import ApiService from "../../../services/ApiService";
import {useEffect, useState} from "react";
import DataGrid from "../../../components/data-grid/DataGrid";
import {Button, Switch, Tag, Tooltip} from "antd";
import {LockOutlined} from "@ant-design/icons";
import UserPermissionsModal from "./UserPermissionsModal";

export default function AccessControlGrid({userId}) {
    const {setData, setPaginationResult, queryModel, setDataGridProps} = useDataGrid();
    const [permModalUser, setPermModalUser] = useState(null);
    const [togglingId, setTogglingId] = useState(null);

    const initGridData = async () => {
        if (userId) {
            queryModel.filter = {userId};
        } else {
            queryModel.filter = {};
        }

        const response = await ApiService.AdminDashboard.GetAccessControlGrid(queryModel);
        if (response?.success) {
            setPaginationResult(response.pagination);
            setData(response.data);
        }
    };

    useEffect(() => {
        initGridData();
    }, [queryModel, userId]);

    const onToggleActive = async (record, isActive) => {
        setTogglingId(record.id);
        try {
            const res = await ApiService.AdminDashboard.SetUserActive({
                userId: record.id,
                isActive,
            });
            if (res?.success) {
                await initGridData();
            }
        } finally {
            setTogglingId(null);
        }
    };

    useEffect(() => {
        setDataGridProps({
            rowKey: 'id',
            enableRowSelection: false,
            columns: [
                {
                    title: 'Register Date',
                    dataIndex: 'createdDate',
                    key: 'createdDate',
                    sorter: false,
                    render: (text) => `${new Date(text).toLocaleString()}`
                },
                {title: 'Name', dataIndex: 'name', key: 'name', sorter: false},
                {title: 'Lastname', dataIndex: 'lastname', key: 'lastname', sorter: false},
                {
                    title: 'Email',
                    dataIndex: 'email',
                    key: 'email',
                    sorter: false,
                    render: (text, record) => (
                        <span>
                            {text}
                            {record.isAdmin && <Tag color={'gold'} style={{marginLeft: 6}}>admin</Tag>}
                        </span>
                    )
                },
                {
                    title: 'Status',
                    dataIndex: 'isActive',
                    key: 'isActive',
                    sorter: false,
                    render: (val, record) => (
                        <Tooltip title={record.isAdmin ? 'Admin users cannot be disabled' : (val ? 'Enabled' : 'Disabled')}>
                            <Switch
                                checked={val}
                                disabled={record.isAdmin || togglingId === record.id}
                                loading={togglingId === record.id}
                                onChange={(checked) => onToggleActive(record, checked)}
                                checkedChildren={'Enabled'}
                                unCheckedChildren={'Disabled'}
                            />
                        </Tooltip>
                    )
                },
                {
                    title: 'Permissions',
                    key: 'permissions',
                    sorter: false,
                    render: (_, record) => (
                        <Button
                            size={'small'}
                            icon={<LockOutlined/>}
                            onClick={() => setPermModalUser(record)}
                        >
                            Manage
                        </Button>
                    )
                },
            ]
        });
    }, [togglingId]);

    return (
        <>
            <DataGrid/>
            <UserPermissionsModal
                user={permModalUser}
                visible={!!permModalUser}
                onClose={() => setPermModalUser(null)}
                onSaved={initGridData}
            />
        </>
    );
}
